module.exports = __webpack_public_path__ + "static/media/prize.5acbfdec.svg";